<div class="col-12" *ngIf="erroralert">
    <div class="alert-box grid-100" *ngIf="errorMessage">
        <div class="alert alert-danger mt-3 text-center">
            <a class="close link" data-dismiss="alert" (click)="erroralert=false">×</a> {{errorMessage}}
        </div>
    </div>
</div>
<div class="col-12" *ngIf="successalert">
    <div class="alert-box grid-100" *ngIf="successMessage">
        <div class="alert alert-success mt-3 text-center">
            <a class="close link" data-dismiss="alert" (click)="successalert=false">×</a> {{successMessage}}
        </div>
    </div>
</div>
<div class="row _67">
  <div class="col-sm-11 ml-5 mt-5 mb-4 pl-0">
    <div class="_45">
      Has the customer contacted other vendors ? 
    </div>
    <button type="button" class="btn _89" [ngClass]="{'btn-pink': HasOtherVender == 'Yes'}" (click)="SelectedVal('Yes')">Yes</button>
    <button type="button" class="btn ml-3 _89" [ngClass]="{'btn-pink': HasOtherVender == 'No'}" (click)="SelectedVal('No')">No</button>
  </div>
  <div class="col-12" *ngIf="information">
    <div class="alert-box grid-100" *ngIf="information">
        <div class="alert alert-info mt-3 text-center">
            <a class="close link" data-dismiss="alert" (click)="information=false">×</a> Competitor Analysis Not Yet Created For This Lead
        </div>
    </div>
  </div>
</div>
<ng-container *ngIf="HasOtherVender=='Yes'">
  <form [formGroup]="competition_analysis">
    <div class="form-group">
      <div class="row form-group m-0 ml-3 mr-3 mt-4">
        <div class="col-sm-12 mt-2">
          <label class="customLabel">Select the most significant competitor <span class="text-danger hideAsteriskIcon">*</span></label>
          <div class="form-check mt-2 opa5" *ngIf="significant_competitor">
            <label for="{{item.key}}" class="form-check-label lableSize labelColor mb-2 mr-4"
                *ngFor="let item of significant_competitor_aaray let i = index">
              <input id="{{item.key}}" type="radio" class="form-check-input" value="{{item.key}}" formControlName="significant_comptitor" (change)="changeSignificant($event,item.key)">
              {{item.key}}
            </label>
          </div>
          <div class="form-check d-none" id="other_significant">
            <input type="text" id="other_significant" formControlName="other_significant_competitor" class="form-control mt-3"
              placeholder="Enter most significant competitor">
          </div>
        </div>
        <div class="col-sm-6 mt-4">
          <label class="customLabel">Method of approaching vendor ?<span class="text-danger hideAsteriskIcon">*</span></label>
          <div class="form-check"> 

            <ng-select placeholder="Select Approaching Vendor" disabled formControlName="approch_vendor" class="filterSelect dissplay-chng1"
              (change)="changeLocality($event)">
              <ng-option value="" disabled>Enter Approaching Vendor </ng-option>
              <ng-option value="audio_call">Audio Call</ng-option>
              <ng-option value="video_call">Video Call </ng-option>
              <ng-option value="others">Others</ng-option>
            </ng-select>

            <div class="form-check d-none" id="localitybuilding">
              <input type="text" id="localitybuilding" formControlName="other_approch_vendor_value" class="form-control mt-3"
                placeholder="Enter Approaching Vendor">
            </div>
          </div>
        </div>
        <div class="col-sm-6 mt-4">
          <div class="ml-3">Extent of connect</div>
          <div class="custom-control custom-checkbox mt-2 opa5">
            <input formControlName="extent_connent_discussions" type="checkbox" class="_43" id="defaultUnchecked" [(ngModel)]="discussions" (change)="extent_of_connect($event,'discussions');">
            <label class="custom-control-label" for="defaultUnchecked"> Discussions </label>
          </div>
          <div class="custom-control custom-checkbox mt-2 opa5">
            <input formControlName="extent_connent_quote" type="checkbox" class="_43" id="defaultUnchecked2" [(ngModel)]="quote" (change)="extent_of_connect($event,'quote');">
            <label class="custom-control-label" for="defaultUnchecked2"> Quote</label>
          </div>
          <div class="custom-control custom-checkbox mt-2 opa5">
            <input formControlName="extent_connent_design" type="checkbox" class="_43" id="defaultUnchecked3" [(ngModel)]="design" (change)="extent_of_connect($event,'design');">
            <label class="custom-control-label" for="defaultUnchecked3">Design</label>
          </div>
        </div>
        <div class="col-sm-6 mt-4">
          <div class="mb-4">Quote<span class="text-danger hideAsteriskIcon">*</span></div>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><span class="_12">&#8377;</span></div>
            </div>
            <input name="Quote" formControlName="quote" type="number" class="form-control" placeholder="Enter Quote Values">
          </div>
        </div>
        <div class="col-sm-6 mt-4 _radioButton">
          <div class="mb-4 ml-3">Is the customer ready to share the designs ?<span class="text-danger hideAsteriskIcon">*</span></div>
          <!--  -->
          <div class="switch-field ml-3">
            <input formControlName="share_design" type="radio" id="radio-one" value="true" checked/>
            <label for="radio-one">Yes</label>
            <input formControlName="share_design"  type="radio" id="radio-two" value="false" />
            <label for="radio-two" class="uncheck">No</label>
          </div>
          <!--  -->
        </div>
        <div class="col-sm-12 mt-4">
          <div class="form-group">
            <label class="customLabel">Note<span class="text-danger hideAsteriskIcon">*</span></label>
            <textarea formControlName="notes" class="form-control"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 mt-4">
      <button class="btn btnSub pull-right mb-4" (click)="submitCompetitionForm(competition_analysis.value,'Yes');" *ngIf="!lead_competitor|| lead_competitor==undefined" [disabled]="competition_analysis.invalid">Submit</button>
      <button class="btn btnSub pull-right mb-4" (click)="updateCompetitionForm(competition_analysis.value,'Yes');" *ngIf="lead_competitor" [disabled]="competition_analysis.invalid">Update</button>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="HasOtherVender=='No'">
  <form [formGroup]="competition_analysis">
    <div class="row mt-5">
      <div class="col-md-11 ml-5">
        <div class="form-group">
            <label class="customLabel">Note<span class="text-danger hideAsteriskIcon">*</span></label>
            <textarea formControlName="selected_no_notes" class="form-control"></textarea>
          </div>
      </div>
    </div>
    <div class="col-sm-12 mt-4">
      <button class="btn btnSub pull-right mb-4" (click)="submitCompetitionForm(competition_analysis.value,'No');" *ngIf="!lead_competitor || lead_competitor==undefined" [disabled]="!competition_analysis.controls['selected_no_notes'].value">Submit</button>
      <button class="btn btnSub pull-right mb-4" (click)="updateCompetitionForm(competition_analysis.value,'Yes');" *ngIf="lead_competitor" [disabled]="!competition_analysis.controls['selected_no_notes'].value">Update</button>
    </div>
  </form>
</ng-container>







<!-- <form [formGroup]="scopeForm">
  <div class="form-group">
    <div class="row form-group m-0 ml-3 mr-3 mt-4" *ngFor="let sheet of scopeForm.get('scope_spaces_attributes')['controls']; let i=index" [formGroup]="sheet" style="border: 1px solid #e8e8e8;">
      <div class="col-sm-12 pt-2 pb-2" style="background-color: #efefef;">
        <div class="row m-0">
          <div class="col-sm-6" style="font-size: 19px;font-weight: 600;color: #8f0521;">
            {{this.scopeForm.value.scope_spaces_attributes[i].space_type | replaceChar}}
          </div>
          <div class="col-sm-6 text-right">
            <button type="button" class="btn btn-pink" (click)="scopeForm.get('scope_spaces_attributes').removeAt(i)">Delete Section</button>
          </div>
        </div>
      </div>
      <div class="col-md-8 mt-4">
        <label class="customLabel"><strong>Space name</strong></label>
        <input type="text" class="form-control" formControlName="space_name" placeholder="">
      </div>

      <div class="row form-group m-0 pb-3" *ngFor="let qna of scopeForm.get('scope_spaces_attributes')['controls'][i].get('scope_qnas_attributes').controls; let j=index" [formGroup]="qna" style="width: 100%;">
        <div class="col-md-8 mt-4">
          <label class="customLabel" style="color: #8f0521;font-size: 19px;"><strong>{{this.scopeForm.value.scope_spaces_attributes[i].scope_qnas_attributes[j].question | replaceChar}}</strong></label>

          <div class="type-data w-100">
            <label class="customLabel"><strong> Arrivae Scope</strong></label>
            <select class="form-control" formControlName="arrivae_scope">
              <option value="n/a">N/A</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div class="type-data w-100">
            <label class="customLabel"><strong> Client Scope</strong></label>
            <select class="form-control" formControlName="client_scope">
              <option value="n/a">N/A</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div class="type-data w-100">
            <label class="customLabel"><strong> Remark</strong></label>
            <textarea class="form-control" formControlName="remark"></textarea>
          </div>


        </div>
      </div>


    </div>

    <div class="row m-0 mt-3 ml-3 mr-3 pt-2 pb-2" style="background-color: #EFEFEF;">
      <div class="col-sm-12" style="display: inline-flex;">
        <select class="form-control col-sm-4 mr-2" (change) = "selectSpace($event)">
          <option value="modular_kitchen">Modular Kitchen</option>
          <option value="services">Services</option>
          <option value="complimentary_items">Complimentary Items</option>
          <option value="bought_out_items">Bought Out Items</option>
          <option value="master_bed_room">Master Bed Room</option>
          <option value="kids_bed_room">Kids Bed Room</option>
          <option value="guest_bed_room">Guest Bed Room</option>
          <option value="living_room">Living Room</option>
          <option value="foyer">Foyer</option>
          <option value="pooja_room">Pooja Room</option>
        </select>
        <button type="button" class="btn btn-pink" (click)="addSpace()">Add Space</button>
      </div>
    </div>
    
  </div>
  <button class="btn btn-pink float-right mb-3" value="submit" (click)="scopeFormSubmit()">Submit</button>
</form> -->



// WEBPACK FOOTER //
// ./src/app/platform/lead/scope-document/scope-document.component.html